import { AdacHeadline, AdacContentExpander } from '@adac-de/component-library';
import React from 'react';
import styles from './faqs.module.scss';
import { Richtext } from '@components/richtext/richtext';

export const FAQs: React.FC<{ headline: string; accordions: Accordion[]; className?: string }> = ({
  headline,
  accordions,
  className
}) => (
  <div className={className}>
    <AdacHeadline tagName="h2" styleAs="h2" className="margin-top--xxl margin-bottom--l">
      {headline}
    </AdacHeadline>
    {accordions.map(
      accordion =>
        accordion.headline &&
        accordion.body && (
          <AdacContentExpander
            className={styles.accordion}
            key={accordion.headline}
            label={
              <AdacHeadline tagName="div" styleAs="h4">
                {accordion.headline}
              </AdacHeadline>
            }
            initiallyExpanded={accordion.initiallyOpen}
          >
            <Richtext textType="medium" document={accordion.body} />
          </AdacContentExpander>
        )
    )}
  </div>
);
